import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import creatorsReducer from '../features/creators/creatorsSlice';
import itemsReducer from '../features/items/itemsSlice';
import cartReducer from '../features/cart/cartSlice';
import analyticsReducer from '../features/analytics/analyticsSlice';
import profileReducer from '../features/profile/profileSlice';
import reviewServicesReducer from '../features/reviewServices/reviewServicesSlice';
import gigServicesReducer from '../features/gigServices/gigServicesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    creators: creatorsReducer,
    items: itemsReducer,
    cart: cartReducer,
    analytics: analyticsReducer,
    profile: profileReducer,
    reviewServices: reviewServicesReducer,
    gigServices: gigServicesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for Firebase auth objects
        ignoredActions: ['auth/setConfirmationResult'],
        // Ignore these field paths in state
        ignoredPaths: ['auth.confirmationResult'],
      },
    }),
});

export default store;